import { FormEvent, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../features/auth/AuthProvider.js";
import { ApiClientError } from "../services/api-client.js";

export function LoginPage(): JSX.Element {
  const { user, bootstrapped, login, authError } = useAuth();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? "/";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);

  if (bootstrapped && user) {
    return <Navigate to={from === "/login" ? "/" : from} replace />;
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setLocalError(null);
    setSubmitting(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      if (!(err instanceof ApiClientError)) {
        setLocalError("Error de red o respuesta inesperada.");
      }
    } finally {
      setSubmitting(false);
    }
  }

  const displayError = localError ?? authError;

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>0xvera Trace</h1>
        <p className="login-subtitle">Portal de cliente — acceso con credenciales de desarrollo</p>
        <p className="text-muted small">
          La autenticación actual es <strong>temporal</strong> (token opaco + <code>sessionStorage</code>), alineada
          con la API. No usar en producción sin sustituir.
        </p>
        <form onSubmit={onSubmit} className="login-form">
          <label className="field">
            <span>Correo</span>
            <input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(ev) => setEmail(ev.target.value)}
              required
              disabled={submitting}
            />
          </label>
          <label className="field">
            <span>Contraseña</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(ev) => setPassword(ev.target.value)}
              required
              disabled={submitting}
            />
          </label>
          {displayError ? <p className="form-error">{displayError}</p> : null}
          <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
            {submitting ? "Entrando…" : "Entrar"}
          </button>
        </form>
        <p className="text-muted small">
          Para probar como usuario de tenant, use por ejemplo <code>admin@acme.trace</code> / <code>dev</code> (semilla
          de la API). Los roles de plataforma también pueden iniciar sesión, pero este portal está pensado para el
          contexto tenant.
        </p>
      </div>
    </div>
  );
}
